import { buildProps, componentSize } from "@xplus/utils/props";
import type { ExtractPropTypes } from "@vue/runtime-core";
export const xFilterGroupProps = buildProps({
  size: {
    type: String,
    default: "default",
    values: componentSize,
  },
} as const);
export type XFilterGroupProps = ExtractPropTypes<typeof xFilterGroupProps>;
